// extracted by mini-css-extract-plugin
module.exports = {"slide__title":"Slide_slide__title__9pKAX","slide__subtitle":"Slide_slide__subtitle__yjBkn","slide__desktopImage":"Slide_slide__desktopImage__nYxMT"};